import { useDispatch, useSelector } from "react-redux"
import { orderActions } from "../../../../../store/orders-slice"

const Pagination = (props) => {

    let dispatch = useDispatch()
    const { index, orders } = props
    let selectedpagination = useSelector(state => state.order.selectedpagination)

    return <button type='button' className={`w-auto mt-3 btn ${selectedpagination == index ? 'active' : ''}`} onClick={() => {
        dispatch(orderActions.setFilteredItems(orders))
        dispatch(orderActions.setSelectedPagination(index))
    }}  >{index + 1}</button>


}

export default Pagination;